<template>
  <vuex-table :fields="fields" :from_first_page="true" table_store="db/databases/show/recipients">
    <template slot="sex" slot-scope="{ item }">
      {{ item.sex ? $t(`db.recipient.modal.import.field_title.${item.sex}`) : '' }}
    </template>
    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span class="dropdown-item-icon dropdown-item-icon--edit" @click="edit(item)">
          {{ $t('shared.component.table.action.edit') }}
        </span>

        <span class="dropdown-item-icon dropdown-item-icon--trash" @click="remove(item)">
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions } from 'vuex';
  import moment from 'moment-es6';
  import { RecipientModalService } from '@db/modals/RecipientModalService';

  function isIsoDate(str) {
    if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
    var d = new Date(str);
    return d.toISOString() === str;
  }

  export default {
    props: {
      database_id: {
        type: [Number, String],
        required: true
      }
    },
    computed: {
      fields: function () {
        return [
          {
            key: 'number',
            label: this.$t('db.recipient.field.number'),
            sortable: true,
            thStyle: {
              minWidth: '200px'
            }
          },

          {
            key: 'email',
            label: this.$t('db.recipient.field.email'),
            sortable: true,
            thStyle: {
              minWidth: '200px'
            }
          },

          {
            key: 'first_name',
            label: this.$t('db.recipient.field.first_name'),
            sortable: true,
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'last_name',
            label: this.$t('db.recipient.field.last_name'),
            sortable: true,
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'age',
            label: this.$t('db.recipient.field.age'),
            sortable: true,
            thStyle: {
              minWidth: '120px'
            }
          },

          {
            key: 'sex',
            label: this.$t('db.recipient.field.sex'),
            sortable: true,
            thStyle: {
              minWidth: '120px'
            }
          },

          {
            key: 'country',
            label: this.$t('db.recipient.field.country'),
            sortable: true,
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'city',
            label: this.$t('db.recipient.field.city'),
            sortable: true,
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'birthdate',
            label: this.$t('db.recipient.field.birthdate'),
            sortable: true,
            formatter: (val) => {
              if (val) {
                if (isIsoDate(val)) {
                  return moment(val).utc(0).format('DD.MM');
                }
                return val;
              } else {
                return '';
              }
            },
            thStyle: {
              minWidth: '200px'
            }
          },

          {
            key: 'custom1',
            label: this.$t('db.recipient.field.custom1'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'custom2',
            label: this.$t('db.recipient.field.custom2'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'custom3',
            label: this.$t('db.recipient.field.custom3'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'custom4',
            label: this.$t('db.recipient.field.custom4'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'custom5',
            label: this.$t('db.recipient.field.custom5'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true,
            class: 'table-created_at'
          },

          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'column-sticky column-sticky--right table-actions'
          }
        ];
      }
    },

    methods: {
      ...mapActions('db/databases/show/recipients', ['getAsyncData']),

      remove(item) {
        const path_params = { database_id: this.database_id, recipient_id: item.id };
        RecipientModalService.remove(path_params, item).on('success', () => this.getAsyncData({ current_page: 1 }));
      },

      edit(item) {
        this.$router.push({
          name: 'db.database.recipient.edit',
          params: {
            database_id: this.database_id,
            recipient_id: item.id,
            item
          }
        });
      }
    }
  };
</script>
